import connectToStores from 'alt-utils/lib/connectToStores';
import React from 'react';

import AuthStore from 'stores/AuthStore';
import SearchFieldsStore from 'stores/search/SearchFieldsStore';
import SearchStore from 'stores/SearchStore';
import SearchTypeIconMenu from 'components/pure/utils/searchType/SearchTypeIconMenu';

/**
 * <SearchTypeIconMenuContainer/> listens to state changes in `SearchFieldsStore` so that it knows
 * which search fields are available to render in the search sidebar and thus decides whether certain
 * search-type(s) should be rendered the search-type-dropdown or not
 */
class SearchTypeIconMenuContainer extends React.Component {
  static getStores() {
    return [AuthStore, SearchFieldsStore, SearchStore];
  }

  static getPropsFromStores() {
    const searchFields = SearchFieldsStore.getState().get('searchFields');
    const isSearchingSelf = SearchStore.getState().get('isSearchingSelf');
    const flags = AuthStore.getState().user.flags;
    return {
      isSearchingSelf: isSearchingSelf,
      searchFields: searchFields,
      flags,
    };
  }

  render() {
    return <SearchTypeIconMenu {...this.props} />;
  }
}

export default connectToStores(SearchTypeIconMenuContainer);
